import { RootState } from "store/store";
import { compose } from "redux";
import { connect } from "react-redux";

import {
    getActiveEnvironmentId,
    getActiveEnvironmentMoniker,
} from "store/environments/environment-selectors";
import { getActiveTenantDeleteWorkflow } from "store/environments/tenants/tenant-delete/tenant-delete-selectors";
import { setLoaderVisibility } from "store/common/initialization/initialization-actions";
import { setIsUnsavedChangeAvailable } from "store/common/unsaved-data/unsaved-data-actions";
import { setTenantDeleteWorkflow } from "store/environments/tenants/tenant-delete/tenant-delete-actions";
import {
    getEnrollSteps,
    getEnrollWorkflow,
} from "store/environments/tenants/enroll-tenant/enroll-tenant-selectors";
import {
    fetchEnrollCache,
    fetchEnrollWorkflow,
} from "store/environments/tenants/enroll-tenant/enroll-tenant-thunks";

import DeleteTenantEnrollBar from "./DeleteTenantEnrollBar";

const mapStateToProps = (state: RootState) => {
    return {
        envMoniker: getActiveEnvironmentMoniker(state),
        activeEnvId: getActiveEnvironmentId(state),
        enrollSteps: getEnrollSteps(state),
        activeTenantDeleteWorkflow: getActiveTenantDeleteWorkflow(state),
        orchestratorInstanceId:
            state.enrollTenantReducer.orchestratorInstanceId,
        enrollCache: state.enrollTenantReducer.enrollCache,
        enrollWorkflow: getEnrollWorkflow(state),
    };
};

const DeleteTenantEnrollBarContainer = compose(
    connect(mapStateToProps, {
        setLoaderVisibility,
        setIsUnsavedChangeAvailable,
        setTenantDeleteWorkflow,
        fetchEnrollWorkflow,
        fetchEnrollCache,
    })
)(DeleteTenantEnrollBar);

export default DeleteTenantEnrollBarContainer;
